import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { P } from "const/permissions";
import { hasPermission } from "utils/permissionUtils";
import CampaignsPanel from "./CampaignsPanel";
import ConnectionPanel from "./ConnectionPanel";
import PostsPanel from "./PostsPanel";
import { useMarketingConnections } from "./useMarketing";

const TABS = { campaigns: "campaigns", posts: "posts", connection: "connection" };
const NO_CONNECTIONS = [];

export default function Marketing() {
  const perms = {
    canConnect: hasPermission(P.MARKETING.ACCOUNT_CONNECT),
    canRead: hasPermission(P.MARKETING.ADS_READ),
    canCreate: hasPermission(P.MARKETING.ADS_CREATE),
    canManage: hasPermission(P.MARKETING.ADS_MANAGE),
    canReadLeads: hasPermission(P.MARKETING.LEADS_READ),
  };
  const canBrowse = perms.canRead || perms.canCreate || perms.canManage;
  const connectionsQuery = useMarketingConnections();
  const connections = connectionsQuery.data || NO_CONNECTIONS;
  const connected = connections.length > 0;

  const [tab, setTab] = useState(null);
  const [openCampaignId, setOpenCampaignId] = useState(null);
  const active =
    tab || (canBrowse && (connected || !perms.canConnect) ? TABS.campaigns : TABS.connection);

  const openCampaign = (id) => {
    setTab(TABS.campaigns);
    setOpenCampaignId(id);
  };

  return (
    <div className="mt-4 space-y-4 px-4 pb-12 text-app-text dashBody">
      <div className="rounded bg-app-surface p-4 shadow-lg">
        <h1 className="text-xl font-semibold">Marketing</h1>
        <p className="text-sm text-app-text-secondary">
          Manage Meta ads in one place, across every connected account. New campaigns and boosts are
          always created paused. Meta only begins spending when someone starts one and confirms it.
        </p>
      </div>

      <div className="rounded bg-app-surface p-4 shadow-lg">
        <Tabs
          value={active}
          onChange={(_, value) => setTab(value)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {canBrowse ? <Tab value={TABS.campaigns} label="Campaigns" /> : null}
          {canBrowse ? <Tab value={TABS.posts} label="Posts" /> : null}
          <Tab value={TABS.connection} label="Connection" />
        </Tabs>

        <div className="pt-4">
          {connectionsQuery.isError ? (
            <p className="text-sm text-app-status-cancelled-text">
              Could not load the Meta accounts.
            </p>
          ) : null}
          {active === TABS.campaigns ? (
            <CampaignsPanel
              connections={connections}
              perms={perms}
              openId={openCampaignId}
              onOpenChange={setOpenCampaignId}
            />
          ) : null}
          {active === TABS.posts ? (
            <PostsPanel connections={connections} perms={perms} onOpenCampaign={openCampaign} />
          ) : null}
          {active === TABS.connection ? (
            <ConnectionPanel connections={connections} canConnect={perms.canConnect} />
          ) : null}
        </div>
      </div>
    </div>
  );
}
